function getBrowserWindow(): Window | null {
  return typeof window !== 'undefined' ? window : null;
}

export function getUrlPathWithParams(): string {
  const browserWindow = getBrowserWindow();
  if (!browserWindow) {
    return '/';
  }

  const { pathname, search } = browserWindow.location;
  const queryParams = new URLSearchParams(search);
  const queryString = queryParams.toString();
  return queryString ? `${pathname}?${queryString}` : pathname;
}

export function getRedirectUrl(path?: string): string {
  const browserWindow = getBrowserWindow();
  if (!browserWindow) {
    return path ?? '/';
  }

  return `${browserWindow.location.origin}${path ?? ''}`;
}

export function isSafeRelativePath(path: string): boolean {
  const browserWindow = getBrowserWindow();
  if (!browserWindow || !path.startsWith('/')) {
    return false;
  }

  try {
    const url = new URL(path, browserWindow.location.origin);
    return url.origin === browserWindow.location.origin;
  } catch {
    return false;
  }
}
